/**
 * AUTH SELECTORS — Accesso allo stato auth dai componenti React.
 *
 * Controparte di `store/thunkHelpers.ts` (che espone `requireGroupId` per i
 * thunk): qui vivono i selettori/hook per i componenti, che non hanno
 * `getState` ma usano `useAppSelector`.
 *
 * Unica fonte di verita' per il `groupId` del sito corrente:
 *   - Thunk  -> `requireGroupId(getState)`       (lancia se non auth)
 *   - Componenti -> `useCurrentGroupId()`         (0 se non auth)
 */

import { useAppSelector } from '../store/hooks';
import type { RootState } from '../store/store';

/**
 * Ritorna il `defaultGroupId` dell'utente loggato, 0 se non autenticato.
 * Il fallback a 0 e' la convenzione del progetto: i componenti che
 * dipendono dal groupId vivono dietro `AuthGuard`, quindi il caso
 * "non autenticato" e' un transitorio (pre-mount) innocuo — lo 0
 * produce query vuote lato backend/MSW, niente crash.
 */
export const selectCurrentGroupId = (state: RootState): number =>
  state.auth.user?.defaultGroupId ?? 0;

/** Hook di comodo per i componenti: `const groupId = useCurrentGroupId()`. */
export const useCurrentGroupId = (): number =>
  useAppSelector(selectCurrentGroupId);
